import React from 'react';

import { loaderClasses } from '../../styles/themeClasses';

const loaderThemeClasses = {
  primary: 'border-black border-t-black/20 border-l-black/20',
  secondary: 'border-white border-t-white/20 border-l-white/20',
};

export interface LoaderProps {
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  theme?: 'primary' | 'secondary';
}

export const Loader: React.FC<LoaderProps> = ({
  size = 'medium',
  theme = 'primary',
}: LoaderProps) => {
  const loaderComponentClasses = `
      ${loaderClasses[size]?.height}
      ${loaderClasses[size]?.width}
      ${loaderThemeClasses[theme]}
      animate-spin inline-block border-[4px]
      rounded-full
    `;
  return (
    <div
      className={loaderComponentClasses}
      role='status'
      aria-label='loading'
    >
      <span className='sr-only'>Loading...</span>
    </div>
  );
};
